import React from "react";
import { connect } from "react-redux";
import { RewardHistoryContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import moment from "moment";
import momentTZ from "moment-timezone";
import * as XLSX from "xlsx";
import { MdLocalShipping } from "react-icons/md";
import { portalService } from "apiServices";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import {
  REWARD_RENDER_TYPE,
  REWARD_RENDER_STATUS,
  REWARD_HISTORY_E_COUPON_RENDER_STATUS,
} from "utils/functions/reward";
import queryString from "query-string";
import { Forms, Inputs, Displays, Modals, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class RewardHistoryContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_REWARD_HISTORY_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
        renderModal: null,
        isLoading: false,
        isBgLoading: false,
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD}/${e}`);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.REWARD_REDEEM}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleClickOfflineReward = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.REWARD}/offline/${e}`);
  };

  handleExport = async (permission) => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let joinQuery = filterQuery
      ? `${filterQuery}&pagination=false`
      : `?pagination=false`;
    let res = await portalService.GET_REWARD_LIST(joinQuery);
    if (res && res.status === 200) {
      let wb = XLSX.utils.book_new();
      let ws_name = "SheetJS";
      /* make worksheet */
      let ws_data = res.data.docs.reduce((result, e, i) => {
        result.push([
          i + 1,
          momentTZ(e.created_at).tz("Asia/Bangkok").format("DD/MM/YYYY"),
          RENDER_CHARACTER_REPLACE_BY_PERMISSION({
            ...permission,
            inputString: e.name,
            action: "export",
          }),
          REWARD_RENDER_TYPE(e.type),
          e.total_amount,
          e.redeem_amount,
          e.redeem_point,
        ]);
        return result;
      }, []);
      ws_data.splice(0, 0, [
        "No",
        "Create Date",
        "Name",
        "Type",
        "Total",
        "Redeem Amount",
        "Redeem Point",
      ]);
      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      let wscols = [
        { wch: 5 },
        { wch: 15 },
        { wch: 30 },
        { wch: 20 },
        { wch: 15 },
        { wch: 15 },
      ];
      ws["!cols"] = wscols;
      /* Add the worksheet to the workbook */
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `activity-report-${moment()
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY")}.xlsx`
      );
      this.setState({
        isBgLoading: false,
      });
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  handleClickShipping = (e) => {
    this.setState({
      renderModal: (
        <Forms.EditSendCompanyForm
          initialValues={e}
          onCancel={this.handleCloseModal}
          onSubmit={this.handleSubmitShipping}
        />
      ),
    });
  };

  handleSubmitShipping = async (values) => {
    this.setState({
      isBgLoading: true,
    });
    let params = {
      service_shipping: values.service_shipping,
      code_shipping: values.code_shipping,
      date_shipping: values.date_shipping,
      status: "4",
    };
    let res = await portalService.PUT_REWARD_HISTORY_UPDATE(values._id, params);
    if (res && res.status === 200) {
      this.fetchData();
    }
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, isBgLoading, pagination, data, renderModal } =
      this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "reward");
    return (
      <RewardHistoryContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
          onExport={
            permission &&
            (permission.is_export || permission.is_export_condition)
              ? () => this.handleExport(permission)
              : false
          }
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({
                  permission: permission,
                  handleClickShipping: this.handleClickShipping,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </RewardHistoryContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "reward_type",
      length: "311px",
      filter: {
        fieldQuery: "reward_type",
        defaultValue: initialValues["reward_type"],
        type: "dropdown",
        label: "Type",
        placeholder: "",
        options: [
          {
            label: "E-coupon",
            value: "1",
          },
          {
            label: "Voucher",
            value: "2",
          },
          {
            label: "Gift",
            value: "3",
          },
        ],
      },
    },
  ];
};

const columns = ({ permission, handleClickShipping }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Name</div>,
    accessor: "member_detail.first_name",
    Cell: (props) => (
      <div>
        {`${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
          ...permission,
          inputString: props.value,
        })} ${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
          ...permission,
          inputString: props.row.original?.member_detail?.last_name,
        })}`}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Type</div>,
    accessor: "reward_type",
    Cell: (props) => <div>{REWARD_RENDER_TYPE(props.value)}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Reward</div>,
    accessor: "reward_name",
    Cell: (props) => <div>{props.value}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Shipping</div>,
    accessor: "address_shipping",
    Cell: (props) => <div>{props.value || "-"}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Status</div>,
    accessor: "status",
    Cell: (props) => (
      <div>
        {props.row.original?.reward_type === "1"
          ? REWARD_HISTORY_E_COUPON_RENDER_STATUS(props.value)?.label
          : REWARD_RENDER_STATUS(props.value)?.label}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Action</div>,
    accessor: "action",
    Cell: (props) =>
      props.row.original.reward_type !== "1" &&
      props.row.original.status !== "1" &&
      props.row.original.status !== "2" && (
        <div onClick={() => handleClickShipping(props.row.original)}>
          <MdLocalShipping fontSize={"18px"} />
        </div>
      ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RewardHistoryContainer));
